import { useState } from "react";
import { Camera, X } from "lucide-react";

const STORAGE_KEY = "savi_avatar_nudge_dismissed";

const AvatarNudgeBanner = ({ user, onAddPhoto }) => {
  const [dismissed, setDismissed] = useState(
    () => typeof window !== "undefined" && localStorage.getItem(STORAGE_KEY) === "1"
  );

  const hasAvatar = !!(user?.profile?.avatar || user?.avatar);
  if (hasAvatar || dismissed) return null;

  const handleDismiss = (e) => {
    e.stopPropagation();
    localStorage.setItem(STORAGE_KEY, "1");
    setDismissed(true);
  };

  return (
    <button
      type="button"
      onClick={onAddPhoto}
      data-testid="avatar-nudge-banner"
      className="w-full text-left mt-4 group relative bg-gradient-to-br from-[#F4ECE2] to-[#E8DAC8] rounded-3xl p-4 sm:p-5 border border-[#C89B7B]/30 hover:border-[#C89B7B]/60 transition-colors"
    >
      <span
        role="button"
        tabIndex={0}
        onClick={handleDismiss}
        onKeyDown={(e) => { if (e.key === "Enter") handleDismiss(e); }}
        className="absolute top-2 right-2 p-1.5 rounded-full text-[#2E2A26]/40 hover:bg-white/40 hover:text-[#2E2A26]"
        data-testid="avatar-nudge-dismiss"
        aria-label="Dismiss"
      >
        <X className="w-4 h-4" />
      </span>
      <div className="flex items-center gap-3 pr-7">
        <div className="w-11 h-11 rounded-full bg-white/60 flex items-center justify-center flex-shrink-0">
          <Camera className="w-5 h-5 text-[#C89B7B]" />
        </div>
        <div className="flex-1">
          <h3 className="font-serif text-base sm:text-lg text-[#2E2A26]">
            Give your profile a fresh photo 📸
          </h3>
          <p className="text-xs sm:text-sm text-[#2E2A26]/70 mt-0.5">
            A face helps your housemates find you on the way to dinner. Tap to add one.
          </p>
        </div>
      </div>
    </button>
  );
};

export default AvatarNudgeBanner;
